import { render, staticRenderFns } from "./cricket-argentina-joins-ludimos-family.vue?vue&type=template&id=7d68689c&scoped=true&"
var script = {}
import style0 from "./cricket-argentina-joins-ludimos-family.vue?vue&type=style&index=0&id=7d68689c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d68689c",
  null
  
)

export default component.exports